/**
 * Z-index tiers for portaled overlays (drawers, dropdown panels, map UI).
 * Keep portal dropdowns at or above drawer overlays so lists stay clickable.
 */
export const UI_Z_INDEX = {
  /** Plantafel activity/absence drawer backdrop + panel. */
  plantafelDrawer: 10050,
  /** Portaled single-select dropdown list (AppSelectDropdown). */
  portalDropdown: 10050,
  /** Portaled multi-select / filter panel (FilterMultiSelect, map date picker). */
  portalPanel: 10050,
  /** In-drawer modal (e.g. delete confirm) — above drawer content, below body portals. */
  plantafelDrawerModal: 10060,
  /** Portaled dropdowns inside a modal — above modal backdrop/panel. */
  portalDropdownInModal: 10070,
  /** Full-screen / centered modals opened above plantafel drawers (e.g. CreateLeadModal). */
  fullscreenModal: 10100,
  /** Save-time confirm (e.g. Einsatzteam nicht verfügbar) — above whichever modal triggered it. */
  saveConfirm: 10110,
  /** Deploy-update prompt — above page chrome and modals. */
  appUpdateBanner: 10200,
} as const;

/** Tailwind arbitrary z-index classes — must be complete literal strings for JIT scanning. */
export const UI_Z_CLASS = {
  plantafelDrawer: 'z-[10050]',
  portalPanel: 'z-[10050]',
  plantafelDrawerModal: 'z-[10060]',
  portalDropdownInModal: 'z-[10070]',
  fullscreenModal: 'z-[10100]',
  saveConfirm: 'z-[10110]',
  appUpdateBanner: 'z-[10200]',
} as const;
